// extracted by mini-css-extract-plugin
module.exports = {"amliLogo":"styles_amliLogo__2Cz1x","socialLogo":"styles_socialLogo__238J7","legalLinks":"styles_legalLinks__1w0OD","socialContainer":"styles_socialContainer__3wLCw"};